// extracted by mini-css-extract-plugin
export default {"main__pin":"RebnderModal_main__pin__qon6Q","opt__box":"RebnderModal_opt__box__-09OX","optCont":"RebnderModal_optCont__1cN6k","submitBtnMain":"RebnderModal_submitBtnMain__kIQeH"};